var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundsBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 673.745,
    height: 604.81,
    viewBox: "0 0 673.745 604.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eff3f6;stroke:#0055ad;stroke-width:15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.555 -15.597)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M503.511,271.024c-.015-.122-.024-.246-.042-.367a14.693,14.693,0,0,0-.364-1.8c0-.006,0-.012-.006-.019a14.841,14.841,0,0,0-.565-1.642c-.063-.155-.131-.3-.2-.456-.173-.39-.365-.775-.574-1.153-.091-.165-.179-.331-.277-.493-.052-.088-.094-.179-.149-.267-.221-.35-.462-.679-.706-1.006-.046-.061-.083-.125-.13-.185a14.481,14.481,0,0,0-1.2-1.356c-.079-.08-.165-.155-.247-.232a15.011,15.011,0,0,0-1.143-1c-.1-.079-.2-.158-.3-.234a15.109,15.109,0,0,0-1.648-1.077L276.428,134.957l126.4-79.594L614.736,175.813l-89.246,56.2a14.9,14.9,0,1,0,15.879,25.219l110.309-69.46a14.9,14.9,0,0,0-.577-25.565L409.8,25.044a14.9,14.9,0,0,0-15.3.344L239.587,122.934l-.1.06-77.408,48.744-.106.067L6.964,269.417a14.9,14.9,0,0,0,.577,25.565l241.3,137.161a14.895,14.895,0,0,0,15.3-.344l110.309-69.461a14.9,14.9,0,1,0-15.879-25.219L255.815,401.826,43.907,281.373l126.4-79.6L396.318,330.245V500.391A14.9,14.9,0,0,0,419.159,513l77.508-48.806a14.9,14.9,0,0,0,6.962-12.61V272.769c0-.088-.015-.171-.018-.259Q503.6,271.767,503.511,271.024ZM426.121,473.4V321.577a14.9,14.9,0,0,0-7.539-12.954L198.92,183.763l48.9-30.791L459.722,273.424l-18.554,11.683a14.9,14.9,0,1,0,15.879,25.219l16.777-10.564v143.6Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M465.247,157.436,354.939,226.9a14.9,14.9,0,1,0,15.879,25.219l110.309-69.46a14.9,14.9,0,0,0-15.879-25.219Z",
    transform: "translate(170.555 64.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.576,296.852,255.814,361.56,22.267,228.808A14.9,14.9,0,1,0,7.54,254.717l241.3,137.161a14.895,14.895,0,0,0,15.3-.344l110.309-69.461a14.9,14.9,0,0,0-15.879-25.221Z",
    transform: "translate(0 99.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M465.247,197.436,354.939,266.9a14.9,14.9,0,1,0,15.879,25.219l110.309-69.46a14.9,14.9,0,0,0-15.879-25.219Z",
    transform: "translate(170.555 84.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.576,336.852,255.814,401.56,22.267,268.808A14.9,14.9,0,0,0,7.54,294.717l241.3,137.161a14.895,14.895,0,0,0,15.3-.344l110.309-69.461a14.9,14.9,0,0,0-15.879-25.221Z",
    transform: "translate(0 119.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M465.247,237.435,354.939,306.9a14.9,14.9,0,1,0,15.879,25.219l110.309-69.46a14.9,14.9,0,1,0-15.879-25.219Z",
    transform: "translate(170.555 103.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M358.576,376.852,255.814,441.56,22.267,308.808A14.9,14.9,0,0,0,7.54,334.717l241.3,137.161a14.895,14.895,0,0,0,15.3-.344l110.309-69.461a14.9,14.9,0,0,0-15.879-25.221Z",
    transform: "translate(0 139.081)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsBlue);
export default __webpack_public_path__ + "static/media/fundsBlue.d2576211.svg";
export { ForwardRef as ReactComponent };